import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import NewsListItem from "@/components/feature/NewsListItem";
import { allNews, getNewsById } from "@/utils/catalog";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NewsDetailPage() {
  const { id } = useParams();
  const item = getNewsById(id || "");

  useDocumentTitle(
    item ? `${item.title} - 娱乐资讯 - 17C.COM` : "娱乐资讯 - 17C.COM",
    item ? item.summary : undefined
  );

  if (!item) {
    return (
      <div className="w-full px-4 md:px-8 py-16">
        <EmptyState
          icon="ri-emotion-sad-line"
          title="资讯内容不存在或已下架"
          description="你访问的资讯可能已被移除，返回资讯分类页看看其他内容吧。"
          actionLabel="返回资讯分类"
          onAction={() => window.REACT_APP_NAVIGATE("/category/news")}
        />
      </div>
    );
  }

  const related = allNews.filter((n) => n.id !== item.id && n.channel === item.channel).slice(0, 5);

  return (
    <div className="w-full">
      <div className="w-full px-4 md:px-8 pt-6 pb-2">
        <Breadcrumb
          items={[{ label: "首页", to: "/" }, { label: "资讯", to: "/category/news" }, { label: item.channel }]}
        />
      </div>

      <div className="w-full px-4 md:px-8 pt-4 pb-10 md:pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <article className="lg:col-span-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-7">
              <div className="flex items-center gap-3 mb-4 flex-wrap">
                <span className="px-2.5 py-0.5 rounded-full text-xs font-label font-medium bg-primary-100 text-primary-700">
                  {item.channel}
                </span>
                <span className="text-sm text-foreground-500 flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {item.date}
                </span>
              </div>

              <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 leading-snug">
                {item.title}
              </h1>

              <div className="mt-5 w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 娱乐资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="mt-6 flex flex-col gap-5">
                {item.content.map((para, index) => (
                  <p
                    key={index}
                    className="text-sm md:text-base leading-relaxed text-foreground-700"
                  >
                    {para}
                  </p>
                ))}
              </div>

              <div className="mt-6 pt-5 border-t border-background-200 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span key={tag} className="px-2.5 py-1 rounded-md text-xs bg-secondary-100 text-secondary-800">
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 flex flex-wrap items-center gap-3 text-sm">
              <span className="text-foreground-600">所属频道：</span>
              <Link to="/category/news" className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 cursor-pointer">
                <i className="ri-newspaper-line"></i>
                娱乐资讯
              </Link>
              <span className="inline-flex items-center gap-1 text-foreground-600">{item.channel}</span>
            </div>
          </article>

          <aside className="lg:col-span-1">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <h2 className="font-heading text-lg font-black text-foreground-950 mb-2 flex items-center gap-2">
                <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
                相关推荐
              </h2>
              {related.length > 0 ? (
                <div className="flex flex-col">
                  {related.map((n) => (
                    <NewsListItem key={n.id} item={n} showSummary={false} />
                  ))}
                </div>
              ) : (
                <p className="text-sm text-foreground-500 py-4">暂无相关推荐内容</p>
              )}
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}